(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Cannon Barrage": {
      play: [{ op: "deal", spec: { type: "unit", enemy: true, inCombat: true }, n: 2 }],
    },

    "Confront": {
      play: [{ op: "unitsEnterReady" }, { op: "draw", n: 1 }],
    },

    "Mobilize": {
      play: [
        {
          op: "if", cond: { k: "runeDeckAtLeast", n: 1 },
          then: [{ op: "channel", n: 1, exhausted: true }],
          else: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "First Mate": {
      targets: [{ bind: "t", spec: { type: "unit", other: true }, prompt: "Ready another unit" }],
      play: [{ op: "ready", to: "$t" }],
    },

    "Crackshot Corsair": {
      triggers: [{
        on: "attack", self: true,
        label: "deal 1 to an enemy unit here",
        targets: [{ bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Deal 1 to which enemy unit here?" }],
        program: [{ op: "deal", to: "$t", n: 1 }],
      }],
    },

    "Dune Drake": {
      triggers: [{
        on: "attack", self: true,
        condSpec: { k: "enemyReadyUnitHere" },
        label: "+2 Might this turn",
        program: [buff("source", 2)],
      }],
    },

    "Kinkou Monk": {
      play: [
        { op: "choose", bind: "t", spec: { type: "unit", friendly: true, other: true }, min: 0, max: 2, prompt: "Buff up to two other friendly units" },
        { op: "buff", to: "$t" },
      ],
    },

    "Wildclaw Shaman": {
      play: [{
        op: "may", prompt: "Spend a buff to buff and ready Wildclaw Shaman?", then: [
          { op: "choose", bind: "b", spec: { type: "unit", friendly: true, hasBuff: true }, prompt: "Spend whose buff?" },
          {
            op: "if", cond: { k: "targetsChosen", bind: "b" }, then: [
              { op: "removeBuff", to: "$b" },
              { op: "buff", to: "source" },
              { op: "ready", to: "source" },
            ],
          },
        ],
      }],
    },

    "Carnivorous Snapvine": {
      play: [
        { op: "choose", bind: "t", spec: { type: "unit", enemy: true, atBf: true }, prompt: "Fight which enemy unit?" },
        { op: "fight", a: "source", b: "$t" },
      ],
    },

    "Anivia, Primal": {
      triggers: [{
        on: "attack", self: true, label: "glacial storm",
        program: [{ op: "deal", spec: { type: "unit", enemy: true, here: true }, n: 3 }],
      }],
    },

    "Warwick, Hunter": {
      entersReady: true,
      triggers: [{
        on: "attack", self: true, label: "blood hunt",
        program: [{ op: "kill", spec: { type: "unit", enemy: true, here: true, damaged: true } }],
      }],
    },

    "Volibear, Imposing": {
      triggers: [{
        on: "move", label: "watchful",
        condSpec: { k: "and", conds: [{ k: "evEnemy" }, { k: "evToBf" }, { k: "evToNotSelfLoc" }] },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Cithria of Cloudfield": {
      triggers: [{
        on: "played", you: true, label: "inspired",
        condSpec: { k: "and", conds: [{ k: "evOther" }, { k: "evType", type: "unit" }] },
        program: [{ op: "buff", to: "source" }],
      }],
    },

    "Miss Fortune, Captain": {
      triggers: [{
        on: "move", self: true, oncePerTurn: true, label: "command",
        program: [{
          op: "may", prompt: "Ready something else that's exhausted?", then: [
            { op: "choose", bind: "t", spec: { friendly: true, ready: false, other: true }, prompt: "Ready what?" },
            { op: "ready", to: "$t" },
          ],
        }],
      }],
    },

    "Qiyana, Victorious": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "spoils",
        program: [
          { op: "option", options: ["Draw 1", "Channel 1 rune exhausted"], varKey: "q" },
          { op: "if", cond: { k: "varEq", key: "q", value: 0 }, then: [{ op: "draw", n: 1 }] },
          { op: "if", cond: { k: "varEq", key: "q", value: 1 }, then: [{ op: "channel", n: 1, exhausted: true }] },
        ],
      }],
    },

    "Sett, Brawler": {
      play: [{ op: "buff", to: "source" }],
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "showing off",
        program: [{ op: "buff", to: "source" }],
      }],
      abilities: [{
        label: "Spend my buff: +4 might this turn", spendBuffSelf: true,
        program: [{ op: "grant", to: "source", might: 4 }],
      }],
    },

    "Bilgewater Bully": {
      selfKwSpecs: [{ name: "ganking", value: null, cond: { k: "selfHasBuff" } }],
    },

    "Lee Sin, Centered": {
      auraMightSpecs: [{ n: 2, scope: "hereBf", excludeSelf: true, targetCond: { k: "selfHasBuff" } }],
    },

    "Herald of Scales": { unitCostMod: { tag: "Dragon", less: 2, min: 1 } },

    "Spoils of War": {
      costMod: { k: "enemyDiedThisTurn", energyLess: 2, min: 0 },
      play: [{ op: "draw", n: 2 }],
    },

    "Deadbloom Predator": { playToEnemyBf: true },

    "Challenge": {
      targets: [
        { bind: "a", spec: { type: "unit", friendly: true }, prompt: "Your champion of the duel" },
        { bind: "b", spec: { type: "unit", enemy: true }, prompt: "The enemy it fights" },
      ],
      play: [{ op: "fight", a: "$a", b: "$b" }],
    },

    "Flurry of Blades": {
      play: [{ op: "deal", spec: { type: "unit", atBf: true }, n: 1 }],
    },

    "Catalyst of Aeons": {
      play: [
        { op: "channel", n: 2, exhausted: true },
        { op: "if", cond: { k: "channeledLessThan", n: 2 }, then: [{ op: "draw", n: 1 }] },
      ],
    },

    "Showstopper": {
      targets: [{ bind: "a", spec: { type: "unit", friendly: true, inBase: true }, prompt: "Buff which unit in your base?" }],
      play: [
        { op: "buff", to: "$a" },
        { op: "move", to: "$a", destType: "bf" },
      ],
    },

    "Arena Bar": {
      abilities: [{
        label: "Exhaust: buff an exhausted friendly unit", exhausts: true,
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", friendly: true, ready: false }, prompt: "Buff which exhausted unit?" },
          { op: "buff", to: "$t" },
        ],
      }],
    },

    "Bounty Hunter": {
      abilities: [{
        label: "Exhaust: give a unit [Ganking] this turn", exhausts: true,
        program: [
          { op: "choose", bind: "t", spec: { type: "unit" }, prompt: "Give which unit Ganking?" },
          { op: "grant", to: "$t", keyword: "ganking" },
        ],
      }],
    },

    "Pirate's Haven": {
      triggers: [{
        on: "ready", you: true, label: "+1 Might",
        condSpec: { k: "and", conds: [{ k: "evFriendly" }, { k: "evType", type: "unit" }] },
        program: [buff("$ev", 1)],
      }],
    },

    "Mistfall": {
      triggers: [{
        on: "buffed", you: true, optional: true, label: "ready the buffed unit",
        condSpec: { k: "and", conds: [{ k: "selfReady" }, { k: "evFriendly" }] },
        program: [
          { op: "payCost", cost: { energy: 0, pips: 1, anyPower: 0, domains: ["body"] }, skipOnFail: 2 },
          { op: "exhaust", to: "source" },
          { op: "ready", to: "$ev" },
        ],
      }],
    },

    "Overt Operation": {
      play: [
        { op: "spendBuffs", thenReady: true, prompt: "Spend a unit's buff to ready it (choose none to stop)" },
        { op: "buff", spec: { type: "unit", friendly: true } },
      ],
    },

    "Sabotage": {
      play: [
        { op: "revealHandPick", who: "opponent", notType: "unit", bind: "_s", prompt: "Recycle which non-unit card?" },
        { op: "recycleTargets", to: "$_s" },
      ],
    },

    "Udyr, Wildman": {
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        spendBuffSelf: true, label: "Udyr, Wildman",
        program: [{
          op: "modalOnce", prompt: "Choose one you've not chosen this turn",
          modes: [
            { label: "Deal 2 to a unit at a battlefield", then: [
              { op: "choose", bind: "_u1", spec: { type: "unit", atBf: true }, prompt: "Deal 2 to which unit?" },
              { op: "deal", to: "$_u1", n: 2 },
            ] },
            { label: "Stun a unit at a battlefield", then: [
              { op: "choose", bind: "_u2", spec: { type: "unit", atBf: true }, prompt: "Stun which unit?" },
              { op: "stun", to: "$_u2" },
            ] },
            { label: "Ready me", then: [{ op: "ready", to: "source" }] },
            { label: "Give me [Ganking] this turn", then: [{ op: "grant", to: "source", keyword: "ganking", dur: "turn" }] },
          ],
        }],
      }],
    },

    "Dazzling Aurora": {
      triggers: [{
        on: "endOfTurn", you: true, label: "reveal until a unit, play it free",
        program: [{
          op: "lookTopTake", n: "untilMatch", filter: { type: "unit" }, public: true,
          prompt: "Play the revealed unit", waive: "all",
        }],
      }],
    },

    "Bullet Time": {
      play: [
        { op: "payAny", res: "power", varKey: "x", prompt: "Pay how much Power?" },
        { op: "chooseDest", varKey: "bf", bfOnly: true, prompt: "Deal the damage at which battlefield?" },
        { op: "deal", n: { varOf: "x" }, spec: { type: "unit", enemy: true }, atVar: "bf" },
      ],
    },

    "The Boss": {
      triggers: [{
        on: "conquer", you: true, label: "ready me",
        program: [{ op: "ready", to: "source" }],
      }],
      legendArm: [{
        op: "optReplaceDeath", dur: "game", once: false, requiresBuff: true,
        exhaustsSource: true, spendBuff: true,
        cost: { energy: 0, pips: 0, anyPower: 1, domains: null },
        label: "The Boss",
      }],
    },

    "Unyielding Spirit": { play: [{ op: "preventAll", nonCombatOnly: true, dur: "turn" }] },

    "Wallop": {
      play: [{ op: "ready", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Ready..." }],
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Wallop",
          costSpendBuff: 1,
          discount: { all: true },
        },
      ],
    },

    "Seal of Strength": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 1, anyPower: 0, domains: ["body"] },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Kraken Hunter": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Kraken Hunter",
          costSpendBuff: "any",
          discountPerPaid: { energy: 0, pips: 1, anyPower: 0, domains: ["body"] },
        },
      ],
    },

    "Mountain Drake": {},

    "Pakaa Cub": {},

    "Pit Rookie": {
      play: [{ op: "buff", to: "$t1" }],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", friendly: true, other: true },
          prompt: "Buff...",
        },
      ],
    },

    "Primal Strength": {
      play: [buff("$t1", 7)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +7 Might to..." }],
    },

    "Stormclaw Ursine": { play: [{ op: "channel", n: 1, exhausted: true }] },
  });
})();
